import { MAX_NOTIFY_CHATS } from "@velizhanin-dev/bot-scenario"
import { Field } from "@/shared/ui/form-field"
import { TextWithVariables } from "@/shared/ui/text-with-variables"
import type { EditorProps } from "../editor-props"
import { readString } from "../editor-props"
import { issuesAt } from "../issues-text"
import { StringListField } from "../string-list-field"

// biome-ignore lint/suspicious/noTemplateCurlyInString: так в конструкторе записываются переменные
const PROFILE_LINK_EXAMPLE = '<a href="tg://user?id=${userId}">${firstName}</a>'

export function NotifyEditor({ config, onChange, issues, draft }: EditorProps) {
	const chatIds = Array.isArray(config.chatIds) ? (config.chatIds as string[]) : []
	return (
		<div className="space-y-4">
			<Field
				label="Куда отправить"
				issues={issuesAt(issues, "chatIds", true)}
				hint="Числовой id: свой можно узнать у @userinfobot, id группы появится, если добавить туда бота. Для канала подойдёт @username, бот должен быть админом. Человек должен хотя бы раз написать боту."
			>
				<StringListField
					values={chatIds}
					onChange={(next) => onChange({ ...config, chatIds: next })}
					placeholder="123456789 или @канал"
					max={MAX_NOTIFY_CHATS}
					itemLabel="чат"
				/>
			</Field>
			<Field label="Текст уведомления" htmlFor="notify-text" issues={issuesAt(issues, "text")}>
				<TextWithVariables
					rich="telegram-html"
					id="notify-text"
					placeholder="Новая заявка: ${firstName}, ${phone}"
					value={readString(config, "text")}
					onChange={(text) => onChange({ ...config, text })}
					variables={draft.variables}
				/>
			</Field>
			<p className="text-xs text-muted-foreground">Ссылка на профиль: {PROFILE_LINK_EXAMPLE}</p>
		</div>
	)
}
